export default {
  BASE_URL: "https://cashexpress.solutia.live",
  MODE: 'production',
};
